import { Link } from '@tanstack/react-router';

import { Button } from './ui/button';
import { cn } from './ui/utils';

export type AuditLinkProps = {
  className?: string;
} & (
  | {
      tag: 'mediaId';
      value: string;
    }
  | {
      tag: 'gamePk';
      value: number;
    }
);

export function AuditLink({ className, tag, value }: AuditLinkProps) {
  return (
    <Button asChild className={cn('text-xs', className)} variant="link">
      <Link
        from="/"
        search={{ tag: { name: tag, value: typeof value === 'number' ? String(value) : value } }}
        to="/audit/audits">
        {value}
      </Link>
    </Button>
  );
}
